import classNames from 'classnames'
import * as React from 'react'

import DynamicComponent from '@/components/DynamicComponent'
import LayoutWrapper from '@/components/LayoutWrapper'

const Placeholder = () => (
  <div className='color-[#1b243f] bg-[#f7f8f9] py-50 px-2 text-center text-[2.6rem] font-bold uppercase'>
    Content 📝
  </div>
)

const Layout = ({children, story = {}}) => {
  const isLayoutPreview = story.component === 'layout'
  const isGlobalPreview = story.component === 'global'

  const {content} = story.layout || {}
  const {top = [], bottom = []} = content || {}

  return (
    <>
      {top.map((component) => (
        <DynamicComponent
          key={component._uid}
          story={story}
          {...component}
          _editable={isLayoutPreview ? component._editable : undefined}
        />
      ))}

      <LayoutWrapper category={story.category?.slug}>
        <main className={classNames('relative z-0', {'min-h-screen': isGlobalPreview})}>
          {isLayoutPreview ? <Placeholder /> : children}
        </main>
      </LayoutWrapper>

      {bottom.map((component) => (
        <DynamicComponent
          key={component._uid}
          story={story}
          {...component}
          _editable={isLayoutPreview ? component._editable : undefined}
        />
      ))}
    </>
  )
}

export default Layout
